export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Image Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/56e0c14de4390827bc6746cccfbbb40f.jpg"
          alt="샌드아트 공연 배경"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 lg:px-12 text-center">
        <div className="space-y-12 animate-fade-in-up">
          {/* Main Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-light text-white tracking-tight leading-tight opacity-0 animate-fade-in-up" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
            모래로 그리는 이야기
          </h1>

          {/* Sub Copy */}
          <p className="text-base md:text-lg text-white/70 font-light max-w-xl mx-auto tracking-wide opacity-0 animate-fade-in-up" style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}>
            순간을 기억으로 남기는 샌드아트
          </p>

          {/* Single CTA */}
          <div className="pt-4 opacity-0 animate-fade-in-up" style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-10 py-4 bg-primary text-white text-sm font-medium tracking-wider uppercase hover:bg-primary/90 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              공연 상담하기
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce-slow">
        <div className="w-px h-16 bg-gradient-to-b from-white/0 via-white/50 to-white/0"></div>
      </div>
    </section>
  );
}